import {
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from "@mui/material";
import React from "react";
import useStyles from "./EdgeAudits.style";
import { ROWS_PER_PAGE_OPTIONS } from "./usePagedAudits";

interface IAuditTableShellProps {
  /** the header row */
  header: React.ReactNode;
  /** the body rows */
  children: React.ReactNode;
  rowCount: number;
  colSpan: number;
  emptyText: string;
  loading: boolean;
  totalCount: number;
  page: number;
  pageSize: number;
  onPageChange: (event: unknown, page: number) => void;
  onPageSizeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/** The DeviceHealthTable chrome without its columns: paper, overlay, empty state, paging. */
const AuditTableShell = ({
  header,
  children,
  rowCount,
  colSpan,
  emptyText,
  loading,
  totalCount,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange
}: IAuditTableShellProps) => {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.tablePaper}>
      <TableContainer className={classes.tableContainer}>
        {loading && (
          <div className={classes.loadingOverlay}>
            <CircularProgress size={32} />
          </div>
        )}
        <Table stickyHeader size="small">
          <TableHead>{header}</TableHead>
          <TableBody>
            {rowCount === 0 ? (
              <TableRow>
                <TableCell colSpan={colSpan} className={classes.emptyCell}>
                  <Typography className={classes.emptyText}>{emptyText}</Typography>
                </TableCell>
              </TableRow>
            ) : (
              children
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        component="div"
        className={classes.pagination}
        count={totalCount}
        page={page}
        rowsPerPage={pageSize}
        rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
        onPageChange={onPageChange}
        onRowsPerPageChange={onPageSizeChange}
      />
    </Paper>
  );
};

export default AuditTableShell;
